import { __rest } from "tslib";
import * as React from 'react';
import BaseFloatingElement from '@cmpkit/base-floating';
import { useDismiss, useFocus, useHover, useInteractions as floatingUiUseInteractions, } from '@floating-ui/react';
function _Tooltip(_a, ref) {
    var { children, content, hidePointer = false, trigger = ['hover', 'focus'], asLabel, delay } = _a, props = __rest(_a, ["children", "content", "hidePointer", "trigger", "asLabel", "delay"]);
    const useInteractions = (context) => floatingUiUseInteractions([
        useHover(context, {
            enabled: trigger.includes('hover'),
            restMs: delay !== null && delay !== void 0 ? delay : 0,
        }),
        useFocus(context, { enabled: trigger.includes('focus') }),
        useDismiss(context),
    ]);
    const contentIsString = typeof content === 'string';
    const showDisabledWarning = () => {
        if (process.env.NODE_ENV !== 'production' && children.props.disabled) {
            console.warn('When passing a component with disabled prop to Tooltip please remember to use a wrapper element, such as a span.');
        }
    };
    React.useEffect(() => showDisabledWarning(), [children.props.disabled]);
    const buildContextAriaAttributes = ({ floating: { id, open }, }) => {
        const attrs = {};
        if (asLabel) {
            attrs['aria-label'] = contentIsString ? content : undefined;
            attrs['aria-labelledby'] = open && !contentIsString ? id : undefined;
        }
        else {
            attrs['aria-describedby'] = open ? id : undefined;
        }
        return attrs;
    };
    const buildFloatingElementAriaAttributes = () => ({
        'aria-hidden': true,
    });
    return (React.createElement(BaseFloatingElement, Object.assign({ ref: ref, path: 'tooltip', className: 'cmp-tooltip__inner', content: content, buildRefElAriaAttributes: buildContextAriaAttributes, buildFloatingElAriaAttributes: buildFloatingElementAriaAttributes, useInteractions: useInteractions, role: !asLabel ? 'tooltip' : undefined, hidePointer: hidePointer }, props), children));
}
const Tooltip = React.forwardRef(_Tooltip);
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map